/* import __COLOCATED_TEMPLATE__ from './class-group-vpa-combined-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class VPACombinedPointsCardComponent extends Component 
{
	@service store;
	@service csv;
	
	@tracked classGroupD1 = null;
	@tracked classGroupD2 = null;
	
	@tracked selectedRacePts = null;//pts destination
	@tracked selectedRacePtsName = null;
	@tracked cachedResults = null;


	@action
	async selectClassGroupD1(event)
	{
		var classGroupId = event.target.value;

		if(classGroupId == '-')
		{
			this.classGroupD1 = null;
			this.cachedResults = null;
		}
		else
		{
			this.classGroupD1 = await this.store.findRecord('classGroup', classGroupId);
			await this.buildResults();
			this.calculateRacePoints();
		}
	}

	@action
	async selectClassGroupD2(event)
	{
		var classGroupId = event.target.value;

		if(classGroupId == '-')
		{
			this.classGroupD2 = null;
			this.cachedResults = null;
		}
		else
		{
			this.classGroupD2 = await this.store.findRecord('classGroup', classGroupId);
			await this.buildResults();
			this.calculateRacePoints();
		}
	}

	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;

		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}

	async buildResults()
	{
		if(!this.classGroupD1 || !this.classGroupD2)
		{
			this.cachedResults = [];
			return;
		}

		const [resultsD1, resultsD2] = await Promise.all([
			this.classGroupD1.get('resultsSorted'),
			this.classGroupD2.get('resultsSorted')
		]);

		// Create plain object copies to avoid mutating original Ember Data models
		const results = resultsD1.concat(resultsD2).map(result => ({
			bib: result.bib,
			club: result.club,
			status: result.status,
			firstName: result.firstName,
			lastName: result.lastName,
			totalTimeFormatted: result.totalTimeFormatted,
			totalTimeInMilliseconds: result.get('totalTimeInMilliseconds'),
			place: null,
			id: result.id,
			validForPoints: false,
			calculatedRacePoints: null
		}));
		results.sort(this.timeSort);

		// Assign combined places
		let currentPlace = 1;
		for(const result of results)
		{
			if(result.status === "OK")
			{
				result.place = currentPlace;
				result.placeOrStatus = currentPlace;
				currentPlace++;
			}
			else
			{
				result.placeOrStatus = result.status;
			}
		}

		this.cachedResults = results;
	}

	get results()
	{
		return this.cachedResults || [];
	}
	
	@action
	async savePoints()
	{
		if(this.classGroupD1 && this.classGroupD2 && this.selectedRacePts != null && this.cachedResults)
		{
			await this.args.event.hasMany('entries').reload();
			var entries = (await this.args.event.get('entries')).slice();
			for(var result of this.cachedResults)
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						await entry.save();
					}
				}
			}
		}
		this.calculateTeamScores();
	}

	calculateRacePoints()
	{
		if(this.classGroupD1 && this.classGroupD2 && this.selectedRacePts != null && this.cachedResults)
		{
			const results = this.cachedResults;
			//sort by team
			results.sort(this.teamSort);
			//check each team for 4 valid starters
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}
			const teams = [];
			for(const team of teamNames)
			{
				teams.push({name:team,count:0});
			}
			//count valid staters for each team
			for(const result of results)
			{
				if(result.status == "OK"||result.status=="DNF"||result.status=="DSQ")
				{
					for(const team of teams)
					{
						if(team.name == result.club)
						{
							team.count++;
						}
					}
				}
			}
			//mark teams as validforpoints
			for(const result of results)
			{
				result.validForPoints = false;
				for(const team of teams)
				{
					if(team.name == result.club)
					{
						if(team.count >3 && result.status == "OK")
						{
							result.validForPoints = true
						}
					}
				}
			}
			//sort by time
			results.sort(this.timeSort)
			//assign points
			let currentPoints = 1;
			let tiePoints = 1;
			let lastTime = null;
			for(const result of results)
			{
				if(result.validForPoints)
				{
					const currentTime = result.totalTimeInMilliseconds;
					if(currentTime != null && currentTime === lastTime)
					{
						// Tie - same time as previous
						result.calculatedRacePoints = tiePoints;
						currentPoints++;
					}
					else
					{
						result.calculatedRacePoints = currentPoints;
						currentPoints++;
						tiePoints = currentPoints;
					}
					lastTime = currentTime;
				}
				else
				{
					result.calculatedRacePoints = 0;
				}
			}
		}
	}

	calculateTeamScores()
	{
		if(this.classGroupD1 && this.classGroupD2 && this.selectedRacePts != null && this.cachedResults)
		{
			let results = this.cachedResults.filter((result) => {
				return result.calculatedRacePoints > 0;
			});
			//sort by school
			results.sort(this.teamSort);
			//collect all the teams
			const teamNames = [];
			for(const result of results)
			{
				if(!teamNames.includes(result.club))
				{
					teamNames.push(result.club);
				}
			}
			results.sort(this.timeSort);
			const teamResults = [];
			teamResults.push([
				"teamName","score1","score2","score3","score4","score5","score6","score7","score8","total"
			]);
			for(const teamName of teamNames)
			{
				let count = 0;
				let sum = 0;
				const scores = [];
				for(const result of results)
				{
					if(result.club == teamName && count < 4)
					{
						sum += result.calculatedRacePoints;
						count++;
						scores.push(result.calculatedRacePoints);
					}
					else if(result.club == teamName)
					{
						scores.push(result.calculatedRacePoints);
					}
				}
				teamResults.push([teamName,scores[0]||"",scores[1]||"",scores[2]||"",scores[3]||"",scores[4]||"",scores[5]||"",scores[6]||"",scores[7]||"",sum]);
			}
			
			this.csv.export(teamResults, {fileName:'teamResults-'+this.classGroupD1.name+'-'+this.classGroupD2.name+'.csv',withSeparator:false});
		}
	}
	
	teamSort(a,b)
	{
		const aClub = a.club || "";
		const bClub = b.club || "";
		return aClub.localeCompare(bClub);
	}
	placeSort(a,b)
	{
		return a.place-b.place;
	}
	timeSort(a,b)
	{
		var aTime = a.totalTimeInMilliseconds;
		var bTime = b.totalTimeInMilliseconds;

		var aPlace = a.place;
		var bPlace = b.place;

		var aStatus = a.status;
		var bStatus = b.status;

		var aID = a.id;
		var bID = b.id;

		//if both results have times, sort on time
		if(aTime != null && bTime != null && aStatus == "OK" && bStatus == "OK")
		{
			//if the times are the same sort on place
			if(aTime == bTime)
			{
				if(aPlace != null && bPlace != null)
					return aPlace>bPlace?1:aPlace<bPlace?-1:0
				if(aPlace != null)
					return -1
				if(bPlace != null)
					return 1
			}
			return (aTime>bTime ? 1 : (aTime<bTime ? -1 : 0));
		}
		if(aTime != null && aStatus == "OK")
			return -1;
		if(bTime != null && bStatus == "OK")
			return 1;

		//no times for either a or b
		//first sort by status, then by id

		//if both have the same status, sort by id
		if(aStatus == bStatus)
		{
			return (aID>bID ? 1 : (aID<bID ? -1 : 0));
		}
		//OK is above everything, SUS is at the bottom
		if(aStatus == "SUS")
		{
			return 1;
		}
		if(bStatus == "SUS")
		{
			return -1;
		}
		if(aStatus == "OK")
		{
			return -1;
		}
		if(bStatus == "OK")
		{
			return 1;
		}
	}
}